import { render } from "./StudentHowKnow.vue?vue&type=template&id=aa08a95e"
import script from "./StudentHowKnow.vue?vue&type=script&lang=js"
export * from "./StudentHowKnow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__